/*
 * @Name: api
 * @Description: 公共api
 * @Author: xiadongxue
 * @Date: 2021-10-21 10:19:10
 * @Editors: xiadongxue
 */
import { axios, jsonPost } from '../assets/js/axios';
let oauth = '/server/oauth/'
//登录
const toLogin = (params) => axios.post(`${oauth}login`,params)
//退出
const logout = () => axios.get(`${oauth}logoutsso`)
//获取邮箱验证码
const forgetPwd = (params) => jsonPost(`${oauth}forgetPwd`,params)
//获取邮箱验证码
const resetPwd = (params) => jsonPost(`${oauth}resetPwd`,params)
//静默登录
const auth = (params) => jsonPost(`${oauth}auth`,params)
//检查第三方登录
const checkLoginSAML = (params) => axios.post(`/server/saml2/check/login`,params)
const checkLoginCAS = (params) => axios.post(`/server/cas/check/login`,params)
//获取登录验证码
const getSmsCode = (params) => jsonPost(`${oauth}getSmsCode`,params)
//预登陆
const preLogin = (params) => jsonPost(`${oauth}preLogin`,params)

let common = '/server/common/'
//获取用户信息
const getLoginInfo = (params) => axios.post(`${common}getMySsoPri`,params)
//获取系统
const getProjects = () => jsonPost(`${common}simpleFindProjects`)
//查询子系统下的角色
const simpleFindRoles = (params) => jsonPost(`${common}simpleFindRoles`,params)
//查询子系统下所有菜单
const simpleFindMenus = (params) => jsonPost(`${common}simpleFindMenus`,params)


//查询所有应用
const getAllApp = () => jsonPost('/server/app/area/sample/get')
//修改密码
const editPwd = (params) => jsonPost('/server/home/editPwd',params)
//根据系统类别查询系统
const getSystemList = (params) => axios.get('/server/project/category/getByCategoryId',{params})
//设置登录类型
const setLoginType = (params) => axios.post('/server/user/set/loginType',params)
//查询google校验
const getTwofactor = (params) => axios.get('/server/user/google/twofactor/get',{params})
//生成google校验
const generatorTwofactor = (params) => axios.post('/server/user/google/twofactor/generator',params)


export {
    toLogin,
    getLoginInfo,
    getProjects,
    simpleFindRoles,
    simpleFindMenus,
    getAllApp,
    editPwd,
    logout,
    forgetPwd,
    resetPwd,
    auth,
    getSmsCode,
    checkLoginSAML,
    checkLoginCAS,
    getSystemList,
    preLogin,
    setLoginType,
    getTwofactor,
    generatorTwofactor
}
